import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const FilterIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 16, height = 16, viewBox = '0 0 16 16' } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38476 15.5C7.13347 15.5 6.92322 15.4153 6.75398 15.2461C6.58475 15.0769 6.50013 14.8666 6.50013 14.6153V8.82688L0.902082 1.71538C0.709782 1.45896 0.681899 1.19229 0.818433 0.915376C0.954966 0.63846 1.18541 0.5 1.50976 0.5H14.4905C14.8148 0.5 15.0452 0.63846 15.1818 0.915376C15.3183 1.19229 15.2904 1.45896 15.0981 1.71538L9.50008 8.82688V14.6153C9.50008 14.8666 9.41547 15.0769 9.24623 15.2461C9.077 15.4153 8.86674 15.5 8.61546 15.5H7.38476ZM8.00011 8.29998L12.9501 1.99998H3.05011L8.00011 8.29998Z"
        fill={color}
      />
    </svg>
  );
};

export default FilterIcon;
